<template>
  <header class="appFesHeader">
    <div class="appFesHeader__brand">
      <img :src="brandImage.src" alt="占いFES">
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import {
  UPDATE_MENU_VISIBILITY,
  UPDATE_SEARCH_VISIBILITY
} from '@/utvStore/store/mutation-types'

export default {
  name: 'appFesHeader',
  data() {
    return {
      brandImage: {
        src: '/static/img/fes/logo.svg',
      }
    }
  },
}</script>

<style lang="scss" scoped>
$breakpoint: 768px;
.appFesHeader {
  background: #ffffff;
  padding: 8px 12px;
  border-bottom: 1px solid #EFEFEF;
  @media (min-width: $breakpoint) {
    padding: 16px 24px;
  }

  &__brand {
    width: 82px;
    height: 28px;
    display: block;

    > img {
      width: 100%;
    }

    @media (min-width: $breakpoint) {
      width: 140px;
      height: 48px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// ../../../../resources/assets/js/uFes/components/AppFesHeader.vue